import { TYPE_IFT } from '../../../src/config';

export default [
	{
		type: 'current',
		number: '826522-80175828',
		product: {
			code: '230',
			name: 'Business Current',
			description: 'NON STANDARD BUSINESS',
			short_description: 'Business Current',
		},
		actions_available: {
			'/account/sweeps': false,
			'/account/alerts/transaction/credit': false,
			'/account/payments/bacscredit/approve': true,
			'/case/customer/read': false,
			'/account/propagate/address': false,
			'/account/payments/batch/out': false,
			'/account/payments/transfer/approve': true,
			'/account/mandates/so/write/recurring': false,
			'/account/books/cheque/reorder': false,
			'/account/transactions/read': true,
			'/users/preferences/write': false,
			'/account/alerts/transaction/debit': false,
			'/case/customer/cancel': false,
			'/case/read': false,
			'/account/propagate/home': false,
			'/account/read': true,
			'/account/pools/write': false,
			'/user/write': false,
			'/account/mandates/so/write': true,
			'/account/payments/bacscredit/out': true,
			'/users/read': false,
			'/account/payments/transfer/out': true,
			'/case/cancel': false,
			'/users/device/manage': false,
			'/account/alerts/balance': false,
			'/account/payments/transfer/in': true,
			'/account/projections': false,
			'/account/sweeps/transfer/out': false,
			'/users/security_device/write': false,
			'/case/customer/managedocs': false,
			'/account/payments/uk/ics/in': false,
			'/users/security_device/read': false,
			'/account/rewards/cashback': false,
			'/account/payments/alerts': false,
			'/users/card/manage': false,
			'/account/beneficiaries/confirmationofpayee': true,
			'/account/propagate/mobile': false,
			'/account/consent': false,
			'/account/mandates/dd/write': true,
			'/account/payments/list/out': false,
			'/case/reassign': false,
			'/account/switch/write': false,
			'/users/preferences/read': false,
			'/account/beneficiaries/import': false,
			'/account/payments/chaps/approve': false,
			'/users/write': false,
			'/account/payments/ift/out': true,
			'/account/mtrack/access': false,
			'/users/permissions/write': false,
			'/account/beneficiaries/read': true,
			'/case/customer/reassign': false,
			'/account/beneficiaries/delete': true,
			'/account/beneficiaries/biller/write': true,
			'/account/payments/read': false,
			'/account/statements/read': true,
			'/account/payments/chaps/out': true,
			'/case/customer/submit': false,
			'/account/mandates/dd/read': true,
			'/account/payments/templates/readwrite': false,
			'/account/transactions/readwrite': false,
			'/case/submit': false,
			'/account/payments/bacsdebit/out': true,
			'/account/payments/ift/approve': false,
			'/user/payments/approve/single': false,
			'/account/payments/uk/default/approve': true,
			'/account/preferences/paperstatementoptout': false,
			'/account/balance/available': true,
			'/account/payments/effectivewarning': true,
			'/account/beneficiaries/account/readwrite': true,
			'/account/payments/uk/default/out': true,
			'/account/statements/order': false,
			'/account/propagate/email': false,
			'/users/strands': false,
			'/account/mandates/so/read': true,
			'/account/read/limited': false,
			'/case/write': false,
			'/account/alerts': false,
			'/users/details/write': false,
			'/account/books/payin/reorder': false,
			'/account/securemessage/write': false,
			'/case/customer/write': false,
			'/user/details/mobile/write': false,
			'/account/securemessage/read': false,
			'/user/payments/approve/dual': true,
			'/account/transactions/write': true,
			'/account/pots': false,
			'/account/mandates/so/update': false,
			'/user/details/address/write': false,
			'/user/details/home/write': false,
			'/user/details/email/write': false,
		},
		source_system: 'IMP',
		bank_id: 'CB',
		metadata: {
			display_order: 0,
			account_name: 'NAC FOR WILLIAM GALLAGHER',
		},
		balances: [
			{
				type: 'current',
				amount: {
					value: 11190.45,
					currency: 'GBP',
				},
			},
			{
				type: 'available',
				amount: {
					value: 11190.45,
					currency: 'GBP',
				},
			},
			{
				type: 'cleared',
				amount: {
					value: 11190.45,
					currency: 'GBP',
				},
			},
		],
		role: 'VIEWCREATEAPPROVE',
		payment_limits: {
			payment_limit: 0,
			approval_limit: 100000,
		},
		id: '88c4a13e-154c-4c15-a47f-acb6fa08fca5',
	},
	{
		id: 'e31e4352-1da6-408a-b874-464009c0ca62',
		type: 'current',
		number: '825000-80104847',
		accountNumber: '80104847',
		actionsAvailable: {
			'/account/transactions/read': false,
			'/account/payments/read': true,
		},
		actions_available: {
			'/account/transactions/read': false,
			'/account/payments/read': true,
		},
		bank_id: 'CB',
		balances: [
			{ type: 'current', amount: 162, currency: 'GBP' },
			{ type: 'available', amount: 162, currency: 'GBP' },
		],
		displayName: 'CURRENT ACCOUNT',
		sortCode: '825000',
		metadata: {
			display_name: 'test account',
			display_order: 0,
		},
		display_order: 0,
	},
	{
		id: '0e4951cf-5134-42d1-8e46-4e52f21d053f',
		type: 'current',
		number: '826817-50017756',
		sortcode: '826817',
		accountNumber: '50017756',
		product: { code: '220', name: 'Business Current', description: 'STANDARD BUSINESS' },
		actions_available: {
			'/account/transactions/read': true,
			'/account/payments/read': true,
		},
		actionsAvailable: {
			'/account/securemessage/read': false,
			'/account/payments/swift/out': false,
			'/account/transactions/readwrite': false,
			'/account/mandates/so/write/recurring': false,
			'/account/sweeps/transfer/out': false,
			'/users/preferences/write': false,
			'/account/books/payin/reorder': false,
			'/account/transactions/write': false,
			'/account/payments/batch/out': false,
			'/account/mandates/so/update': false,
			'/account/sweeps': false,
			'/account/beneficiaries/delete': true,
			'/account/payments/read': false,
			'/account/payments/uk/ics/in': false,
			'/users/read': false,
			'/users/security_device/read': false,
			'/account/payments/alerts': false,
			'/account/payments/uk/default/out': true,
			'/users/details/write': false,
			'/users/write': false,
			'/account/payments/templates/readwrite': false,
			'/account/transactions/read': true,
			'/account/pots': false,
			'/account/payments/bacscredit/out': false,
			'/account/mandates/so/write': true,
			'/account/payments/transfer/in': true,
			'/user/write': false,
			'/account/statements/order': false,
			'/account/mandates/so/read': true,
			'/account/books/cheque/reorder': false,
			'/account/beneficiaries/import': false,
			'/account/beneficiaries/read': true,
			'/account/beneficiaries/biller/write': true,
			'/account/payments/list/out': false,
			'/account/payments/chaps/out': false,
			'/account/projections': false,
			'/account/read/limited': false,
			'/account/beneficiaries/account/readwrite': true,
			'/account/preferences/paperstatementoptout': false,
			'/account/payments/transfer/out': true,
			'/users/preferences/read': false,
			'/users/security_device/write': false,
			'/account/alerts': true,
			'/account/consent': false,
			'/users/permissions/write': false,
			'/account/read': true,
			'/account/mandates/dd/read': true,
			'/account/statements/read': false,
			'/account/payments/bacsdebit/out': false,
			'/account/securemessage/write': false,
			'/account/mandates/dd/write': true,
		},
		bank_id: 'CB',
		metadata: { display_name: null, display_order: 0, account_name: 'Joes Carpenter Business Account' },
		displayName: 'Business Current',
		balances: [
			{ type: 'current', amount: 162, currency: 'GBP' },
			{ type: 'available', amount: 162, currency: 'GBP' },
		],
		code: null,
		showIcon: null,
		display_order: 1,
		sortCode: '826817',
	},
	{
		id: '31c99053-b219-4c52-8753-e9311a5e87da',
		type: 'credit_card',
		number: '************8214',
		sortcode: null,
		product: { code: '0001', name: 'CREDIT CARD', description: 'CREDITCARD' },
		actionsAvailable: {
			'/account/securemessage/read': false,
			'/account/payments/swift/out': false,
			'/account/transactions/readwrite': false,
			'/account/mandates/so/write/recurring': false,
			'/account/sweeps/transfer/out': false,
			'/users/preferences/write': false,
			'/account/books/payin/reorder': false,
			'/account/transactions/write': false,
			'/account/payments/batch/out': false,
			'/account/mandates/so/update': false,
			'/account/sweeps': false,
			'/account/beneficiaries/delete': true,
			'/account/payments/read': false,
			'/account/payments/uk/ics/in': false,
			'/users/read': false,
			'/users/security_device/read': false,
			'/account/payments/alerts': false,
			'/account/payments/uk/default/out': true,
			'/users/details/write': false,
			'/users/write': false,
			'/account/payments/templates/readwrite': false,
			'/account/transactions/read': true,
			'/account/pots': false,
			'/account/payments/bacscredit/out': false,
			'/account/mandates/so/write': true,
			'/account/payments/transfer/in': true,
			'/user/write': false,
			'/account/statements/order': false,
			'/account/mandates/so/read': true,
			'/account/books/cheque/reorder': false,
			'/account/beneficiaries/import': false,
			'/account/beneficiaries/read': true,
			'/account/beneficiaries/biller/write': true,
			'/account/payments/list/out': false,
			'/account/payments/chaps/out': false,
			'/account/projections': false,
			'/account/read/limited': false,
			'/account/beneficiaries/account/readwrite': true,
			'/account/preferences/paperstatementoptout': false,
			'/account/payments/transfer/out': true,
			'/users/preferences/read': false,
			'/users/security_device/write': false,
			'/account/alerts': false,
			'/account/consent': false,
			'/users/permissions/write': false,
			'/account/read': true,
			'/account/mandates/dd/read': false,
			'/account/statements/read': false,
			'/account/payments/bacsdebit/out': false,
			'/account/securemessage/write': false,
			'/account/mandates/dd/write': false,
		},
		bank_id: 'CB',
		metadata: { display_name: null, display_order: 0 },
		displayName: 'CREDIT CARD',
		balances: [
			{ type: 'current', amount: 0, currency: 'GBP' },
			{ type: 'available', amount: 5900, currency: 'GBP' },
		],
		code: null,
		showIcon: null,
		display_order: 2,
		sortCode: '************8214',
	},
	{
		id: '87df0812-6ea2-4167-b330-15f7dc9cb999',
		type: 'current',
		number: '821208-50013514',
		sortcode: null,
		accountNumber: '50013514',
		product: { code: '540', name: 'CURRENT ACCOUNT', description: ' CURRENT ACCOUNT DIRECT' },
		actionsAvailable: {
			'/account/securemessage/read': false,
			'/account/payments/swift/out': false,
			'/account/transactions/readwrite': false,
			'/account/mandates/so/write/recurring': false,
			'/account/sweeps/transfer/out': false,
			'/users/preferences/write': false,
			'/account/books/payin/reorder': false,
			'/account/transactions/write': false,
			'/account/payments/batch/out': false,
			'/account/mandates/so/update': false,
			'/account/sweeps': false,
			'/account/beneficiaries/delete': true,
			'/account/payments/read': false,
			'/account/payments/uk/ics/in': false,
			'/users/read': false,
			'/users/security_device/read': false,
			'/account/payments/alerts': false,
			'/account/payments/uk/default/out': true,
			'/users/details/write': false,
			'/users/write': false,
			'/account/payments/templates/readwrite': false,
			'/account/transactions/read': true,
			'/account/pots': false,
			'/account/payments/bacscredit/out': false,
			'/account/mandates/so/write': true,
			'/account/payments/transfer/in': true,
			'/user/write': false,
			'/account/statements/order': false,
			'/account/mandates/so/read': true,
			'/account/books/cheque/reorder': false,
			'/account/beneficiaries/import': false,
			'/account/beneficiaries/read': true,
			'/account/beneficiaries/biller/write': true,
			'/account/payments/list/out': false,
			'/account/payments/chaps/out': false,
			'/account/projections': false,
			'/account/read/limited': false,
			'/account/beneficiaries/account/readwrite': true,
			'/account/preferences/paperstatementoptout': false,
			'/account/payments/transfer/out': true,
			'/users/preferences/read': false,
			'/users/security_device/write': false,
			'/account/alerts': true,
			'/account/consent': false,
			'/users/permissions/write': false,
			'/account/read': true,
			'/account/mandates/dd/read': true,
			'/account/statements/read': true,
			'/account/payments/bacsdebit/out': false,
			'/account/securemessage/write': false,
			'/account/mandates/dd/write': true,
		},
		bank_id: 'CB',
		metadata: { display_name: null, display_order: 0 },
		displayName: 'CURRENT ACCOUNT',
		balances: [
			{ type: 'current', amount: 11, currency: 'GBP' },
			{ type: 'available', amount: 11, currency: 'GBP' },
		],
		code: null,
		showIcon: null,
		display_order: 3,
		sortCode: '821208',
	},
	{
		id: '1b155dce-f065-43c6-8db6-89bdb57b871c',
		type: 'current',
		number: '822000-12345678',
		accountNumber: '12345678',
		product: { code: '395', name: 'CURRENT ACCOUNT', description: 'PROPERTY DEV BASE FACILITY- BUS CURR ACC' },
		actionsAvailable: {
			'/account/securemessage/read': false,
			'/account/payments/swift/out': false,
			'/account/transactions/readwrite': false,
			'/account/mandates/so/write/recurring': false,
			'/account/sweeps/transfer/out': false,
			'/users/preferences/write': false,
			'/account/books/payin/reorder': false,
			'/account/transactions/write': false,
			'/account/payments/batch/out': false,
			'/account/mandates/so/update': false,
			'/account/sweeps': false,
			'/account/beneficiaries/delete': false,
			'/account/payments/read': false,
			'/account/payments/uk/ics/in': false,
			'/users/read': false,
			'/users/security_device/read': false,
			'/account/payments/alerts': false,
			'/account/payments/uk/default/out': false,
			'/users/details/write': false,
			'/users/write': false,
			'/account/payments/templates/readwrite': false,
			'/account/transactions/read': true,
			'/account/pots': false,
			'/account/payments/bacscredit/out': false,
			'/account/mandates/so/write': false,
			'/account/payments/transfer/in': true,
			'/user/write': false,
			'/account/statements/order': false,
			'/account/mandates/so/read': false,
			'/account/books/cheque/reorder': false,
			'/account/beneficiaries/import': false,
			'/account/beneficiaries/read': false,
			'/account/beneficiaries/biller/write': false,
			'/account/payments/list/out': false,
			'/account/payments/chaps/out': false,
			'/account/projections': false,
			'/account/read/limited': false,
			'/account/beneficiaries/account/readwrite': false,
			'/account/preferences/paperstatementoptout': false,
			'/account/payments/transfer/out': false,
			'/users/preferences/read': false,
			'/users/security_device/write': false,
			'/account/alerts': false,
			'/account/consent': false,
			'/users/permissions/write': false,
			'/account/read': true,
			'/account/mandates/dd/read': false,
			'/account/statements/read': true,
			'/account/payments/bacsdebit/out': false,
			'/account/securemessage/write': false,
			'/account/mandates/dd/write': false,
		},
		bank_id: 'CB',
		metadata: { display_name: null, display_order: 0 },
		displayName: 'CURRENT ACCOUNT',
		balances: [
			{ type: 'current', amount: 515, currency: 'GBP' },
			{ type: 'available', amount: 515, currency: 'GBP' },
		],
		code: null,
		showIcon: null,
		display_order: 4,
		sortCode: '822000',
	},
	{
		id: 'da242f55-7c7a-4acf-9746-f3e8b9128762',
		type: 'current',
		number: '822000-80104490',
		sortcode: null,
		accountNumber: '80104490',
		product: { code: '250', name: 'CURRENT ACCOUNT', description: 'PFCA' },
		actionsAvailable: {
			'/account/securemessage/read': false,
			'/account/payments/swift/out': false,
			'/account/transactions/readwrite': false,
			'/account/mandates/so/write/recurring': false,
			'/account/sweeps/transfer/out': false,
			'/users/preferences/write': false,
			'/account/books/payin/reorder': false,
			'/account/transactions/write': false,
			'/account/payments/batch/out': false,
			'/account/mandates/so/update': false,
			'/account/sweeps': false,
			'/account/beneficiaries/delete': false,
			'/account/payments/read': false,
			'/account/payments/uk/ics/in': false,
			'/users/read': false,
			'/users/security_device/read': false,
			'/account/payments/alerts': false,
			'/account/payments/uk/default/out': true,
			'/users/details/write': false,
			'/users/write': false,
			'/account/payments/templates/readwrite': false,
			'/account/transactions/read': true,
			'/account/pots': false,
			'/account/payments/bacscredit/out': false,
			'/account/mandates/so/write': true,
			'/account/payments/transfer/in': true,
			'/user/write': false,
			'/account/statements/order': false,
			'/account/mandates/so/read': true,
			'/account/books/cheque/reorder': false,
			'/account/beneficiaries/import': false,
			'/account/beneficiaries/read': false,
			'/account/beneficiaries/biller/write': false,
			'/account/payments/list/out': false,
			'/account/payments/chaps/out': false,
			'/account/projections': false,
			'/account/read/limited': false,
			'/account/beneficiaries/account/readwrite': false,
			'/account/preferences/paperstatementoptout': false,
			'/account/payments/transfer/out': true,
			'/users/preferences/read': false,
			'/users/security_device/write': false,
			'/account/alerts': false,
			'/account/consent': false,
			'/users/permissions/write': false,
			'/account/read': true,
			'/account/mandates/dd/read': true,
			'/account/statements/read': true,
			'/account/payments/bacsdebit/out': false,
			'/account/securemessage/write': false,
			'/account/mandates/dd/write': true,
		},
		bank_id: 'CB',
		metadata: { display_name: null, display_order: 0 },
		displayName: 'CURRENT ACCOUNT',
		balances: [],
		code: null,
		showIcon: null,
		display_order: 5,
		sortCode: '822000',
	},
	{
		id: 'd4e94264-eb9a-4348-ab18-82a5e4c942b2',
		type: TYPE_IFT,
		number: '50017756334563546',
		sortcode: null,
		accountNumber: '50017756334563546',
		product: { code: '165', name: 'SAVINGS', description: 'CYBERSAVE' },
		actionsAvailable: {
			'/account/securemessage/read': false,
			'/account/payments/swift/out': false,
			'/account/transactions/readwrite': false,
			'/account/mandates/so/write/recurring': false,
			'/account/sweeps/transfer/out': false,
			'/users/preferences/write': false,
			'/account/books/payin/reorder': false,
			'/account/transactions/write': false,
			'/account/payments/batch/out': false,
			'/account/mandates/so/update': false,
			'/account/sweeps': false,
			'/account/beneficiaries/delete': false,
			'/account/payments/read': false,
			'/account/payments/uk/ics/in': false,
			'/users/read': false,
			'/users/security_device/read': false,
			'/account/payments/alerts': false,
			'/account/payments/uk/default/out': true,
			'/users/details/write': false,
			'/users/write': false,
			'/account/payments/templates/readwrite': false,
			'/account/transactions/read': true,
			'/account/pots': false,
			'/account/payments/bacscredit/out': false,
			'/account/mandates/so/write': true,
			'/account/payments/transfer/in': true,
			'/user/write': false,
			'/account/statements/order': false,
			'/account/mandates/so/read': true,
			'/account/books/cheque/reorder': false,
			'/account/beneficiaries/import': false,
			'/account/beneficiaries/read': false,
			'/account/beneficiaries/biller/write': true,
			'/account/payments/list/out': false,
			'/account/payments/chaps/out': false,
			'/account/projections': false,
			'/account/read/limited': false,
			'/account/beneficiaries/account/readwrite': false,
			'/account/preferences/paperstatementoptout': false,
			'/account/payments/transfer/out': true,
			'/users/preferences/read': false,
			'/users/security_device/write': false,
			'/account/alerts': false,
			'/account/consent': false,
			'/users/permissions/write': false,
			'/account/read': true,
			'/account/mandates/dd/read': false,
			'/account/statements/read': false,
			'/account/payments/bacsdebit/out': false,
			'/account/securemessage/write': false,
			'/account/mandates/dd/write': false,
		},
		bank_id: 'CB',
		metadata: { display_name: null, display_order: 0 },
		displayName: 'IFT ACCOUNT',
		balances: [
			{ type: 'current', amount: 179.25, currency: 'GBP' },
			{ type: 'available', amount: 179.25, currency: 'GBP' },
		],
		code: null,
		showIcon: null,
		display_order: 6,
		sortCode: '',
	},
];
